var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loaded
      ? _c(
          "div",
          { staticClass: "main__fixed" },
          [
            _c("mainMenu", {
              staticClass: "fixed__menu",
              attrs: {
                line: "i_l_b",
                open: "i",
                items: _vm.data.menu,
                data: {
                  logo: _vm.data.logo,
                  o_logo: _vm.data.logo,
                  items: { visible: !_vm.inMobile },
                  button: {
                    img: ["/img/header/open-menu.svg", "/img/header/close.svg"],
                    visible: _vm.inMobile
                  }
                },
                getItemClass: _vm.menuItemClass
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }